import UpdateUser from "../components/configuration/users/UpdateUser";

const UserUpdatePage = () => {
    return <UpdateUser />;
}

export default UserUpdatePage;
